import React from 'react'

class DisabledTabButtonComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <button
          style={styles.button}
          onClick={this.props.onClick}>
          <span style={styles.label}>{this.props.label}</span>
          <img
            style={styles.icon}
            src={this.props.img}
            alt='true'
          />
        </button>
      </div>
    )
  }
}

const styles = {
  buttonContent: {
    marginTop: '6px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: 'auto',
    minWidth: '156px',
    height: '28px',
    marginLeft: '12px',
    border: '1px solid #748591',
    borderRadius: '10px',
    backgroundColor: '#16191C',
    outline: 'none'
  },
  label: {
    textAlign: 'center',
    color: '#748591',
    fontSize: '10px',
    fontWeight: 700
  },
  icon: {
    float: 'right',
    marginLeft: '4px'
  }
}

export default DisabledTabButtonComponent
